'use-client';
import * as React from 'react';
import type { VerticalLineProps } from '../VerticalLine';
import type { IVerticalLineProps } from '../../../VerticalLine.types';
import VerticalLine from '../../VerticalLine';
import skinsStyle from './styles/VerticalIronLine.scss';
import { BaseVerticalLine } from './BaseVerticalLine';

const VerticalIronLineSkin: React.FC<VerticalLineProps> = props => (
  <BaseVerticalLine {...props} skinsStyle={skinsStyle} />
);

const VerticalIronLine: React.FC<Omit<IVerticalLineProps, 'skin'>> = props => {
  return <VerticalLine {...props} skin={VerticalIronLineSkin} />;
};

export default VerticalIronLine;
